<template>
  <topbar
    :titulo="$t('FINANCEIRO.BOLETO')"
    :subtitulo="$t('FINANCEIRO.TELA_PAGAMENTOS_DESCRICAO')"
    :breadcrumbs="breadcrumbs"
  />
</template>
<script>
// Utils & Aux:
import rotas from "@/common/utils/rotas";
import Topbar from "@/layouts/full-layout/horizontal-sidebar/Topbar.vue";

// Components:

export default {
  components: { Topbar },
  data() {
    return {
      breadcrumbs: [
        { titulo: this.$t("FINANCEIRO.FINANCEIRO") },
        { titulo: this.$t("FINANCEIRO.PAGAMENTOS") },
      ],
    };
  },
  methods: {
    // FUNÇÕES CRUD:
    cadastrar() {
      this.$emit("cadastrar", "disciplina");
    },
    // FUNÇÕES AUXILIARES:
    irPara() {
      rotas.retornar();
    },
  },
};
</script>
